<script lang="ts">
  import { SidebarType } from "../../utils/Constant/Constant";
  import CommenUl from "./CommenUl.svelte";
  import {sidebarClass,sidebarClose,horizontalSidebar} from "../../store"
  let y:number
//   for layout grid
  const handleSidebarType =(getClass:string) => {
    if(y > 991){
        sidebarClass.update(value => value = getClass)
        horizontalSidebar.update(value => value = getClass)
    }else{
        sidebarClass.update(value => value = "compact-wrapper")
    }
  }

</script>
<svelte:window bind:innerWidth={y} />
<h6>{SidebarType}</h6>
<ul  class= 'sidebar-type layout-grid' >
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li class= 'normal-sidebar' on:click={()=>handleSidebarType('horizontal-wrapper')}>
        <CommenUl/>
        <div class="body">
            <ul>
                <li class= 'bg-dark sidebar'></li>
                <li class= 'bg-light body'></li>
            </ul>
        </div>
    </li>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li class="compact-sidebar" on:click={()=>handleSidebarType('compact-wrapper')}>
        <CommenUl/>
        <div class="body">
            <ul>
                <li class= 'bg-dark sidebar compact'></li>
                <li class= 'bg-light body'></li>
            </ul>
        </div>
    </li>
</ul>